import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import MainProjectInfo from '../../../widgets/projectBasedItemsWidget/MainProjectInfo'
import AppendixWidget from '../../../widgets/projectProposal/appendix/AppendixWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID, TEMP_FORM_ID } from '../../../constants/constants'
import { getFormProjectAppendix } from '../../../redux/actions/subProjectProposal'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import { getSettingFormProjectAppendixPreView } from '../../../redux/actions/subProjectFormSetting'

export default function Appendix(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    // setSchema(mockSchema)
    if (mode == 'preView' && formId) {
      handleGetSchemaPreView()
    } else if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //let _schema = cloneDeep(mockSchema) //await getProjectName(proposalId)
      let _schema = await getFormProjectAppendix(subProjectId)

      setSchema(_schema)
      setIsEditWidget({
        appendix: _schema.forms?.appendix?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.appendix?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPreView = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSettingFormProjectAppendixPreView(formId)

      setSchema(_schema)
      setIsEditWidget({
        appendix: true,
      })

      setShowEditAll(false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject mode={mode}>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={schema.buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}

          {schema?.forms?.appendix && (
            <AppendixWidget
              showCommandButton={!schema.forms.appendix.disabled}
              schema={schema.forms.appendix}
              isEdit={isEditWidget.appendix}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('appendix', _isEdit, setIsEditWidget)
              }
              loadMenu={true}
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
